import { atom } from 'jotai';
import { DataMonitorPageState } from './datamonitor_list_types';

export const dataMonitorPageStateAtom = atom<DataMonitorPageState>({
    activeTab: 'MONITORS',
    facility: {
        val: '',
        options: [],
        valid: false,
    },
    loading: true,
    wacOrderingStatus: null,
    deepLinkMonitorType: null,
});
